import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * DomainProtectedRoute - Protects routes based on domain-specific permissions
 * Redirects users without access to the first domain they have access to
 */
const DomainProtectedRoute = ({ children, domain }) => {
  const { user, canAccessDomain, loading } = useAuth();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '400px'
      }}>
        <div className="spinner" style={{
          width: '40px',
          height: '40px',
          border: '3px solid #e2e8f0',
          borderTopColor: '#1e3a5f',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite'
        }}></div>
      </div>
    );
  }

  // Check if user has access to this domain
  if (!canAccessDomain(domain)) {
    // Find the first domain the user has access to
    const domains = ['marketing', 'finance', 'sales', 'manufacturing', 'projects', 'logistics'];
    const firstAccessibleDomain = domains.find(d => canAccessDomain(d));

    // If user has access to at least one domain, redirect there
    if (firstAccessibleDomain) {
      return <Navigate to={`/${firstAccessibleDomain}`} replace />;
    }

    // If user has no domain access, show access denied message
    return (
      <div style={{
        padding: '60px 20px',
        textAlign: 'center',
        maxWidth: '600px',
        margin: '0 auto'
      }}>
        <div style={{
          fontSize: '64px',
          marginBottom: '20px'
        }}>🔒</div>
        <h1 style={{ color: '#1e3a5f', marginBottom: '16px' }}>Access Denied</h1>
        <p style={{ fontSize: '18px', color: '#666', marginBottom: '8px' }}>
          You don't have permission to access this domain.
        </p>
        <p style={{ color: '#999', marginBottom: '32px' }}>
          Please contact your administrator to request access.
        </p>
        <div style={{
          background: '#f8f9fa',
          border: '1px solid #e8eef5',
          borderRadius: '8px',
          padding: '16px',
          textAlign: 'left'
        }}>
          <p style={{ margin: 0, fontSize: '14px', color: '#6b7c93' }}>
            <strong>User:</strong> {user?.username}<br />
            <strong>Domain:</strong> {domain}
          </p>
        </div>
      </div>
    );
  }

  return children;
};

export default DomainProtectedRoute;
